const text = 'text';
const dropdown = 'dropdown';
const image = 'image';
const number = 'number';
const multiSelect = 'multiSelect';
const date = 'date';
const block = 'block';
const barcode = 'barcode';
const signature = 'signature';

export default { text, dropdown, image, number, date, block, multiSelect, barcode, signature };
